import React, { FC } from 'react';
import { Typography, Button, Grid } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { useSelector } from 'react-redux';
import { IRootState } from 'stores';
import { BeneficiariesState } from 'stores/beneficiaries';
import { BeneficiaryView } from 'services/beneficiaries.service';
import { formatTaxNumber } from 'utils/formatters';

type BeneficiaryRowProps = {
  counterparty: BeneficiaryView;
  onEdit: (id: number) => void;
};

const BeneficiaryRow: FC<BeneficiaryRowProps> = ({ counterparty, onEdit }) => {
  const { type } = useSelector<IRootState, BeneficiariesState>(({ beneficiaries }) => beneficiaries);

  return (
    <Grid
      container
      border="1px solid #e0e0e0"
      borderRadius="8px"
      p={3}
      mb={2}
      bgcolor={counterparty.isActive === false ? 'grey.100' : 'transparent'}
    >
      <Grid item xs={4}>
        <Typography fontSize={16} fontWeight={500}>
          {counterparty.tradingName}
        </Typography>
        <Typography fontSize={12} color="text.secondary" bgcolor="grey.200" py={0.5} px={1} borderRadius={4} width="fit-content">
          {counterparty.category || 'Sem categoria'}
        </Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography fontSize={16} fontWeight={500}>
          {counterparty.businessName}
        </Typography>
        <Typography fontSize={14} color="text.secondary">
          {formatTaxNumber(counterparty?.taxNumber || '')}
        </Typography>
      </Grid>

      {(type === 'envio' || type === 'titularidade') && (
        <Grid item xs={3}>
          <Typography fontSize={16} fontWeight={500}>
            {counterparty.bankCode ? 'Dados da conta' : 'Chave PIX'}
          </Typography>
          <Typography fontSize={14} color="text.secondary">
            {counterparty.bankCode
              ? `${counterparty.bankCode} | ${counterparty.branch} | ${counterparty.accountNumber}-${counterparty.accountDigit}`
              : counterparty.pixKey}
          </Typography>
        </Grid>
      )}

      {type === 'boleto' && (
        <Grid item xs={3}>
          {counterparty.allowLatePayment && (
            <Typography fontSize={14} color="text.primary" borderRadius={4} mb={0.5}>
              <FiberManualRecordIcon sx={{ fontSize: 8, color: 'green' }} /> Permite pagamento em atraso
            </Typography>
          )}

          {counterparty.earlyPaymentDiscountEnabled && (
            <Typography fontSize={14} color="text.primary" borderRadius={4}>
              <FiberManualRecordIcon sx={{ fontSize: 8, color: 'green' }} /> Permite desconto antecipado
            </Typography>
          )}
        </Grid>
      )}

      <Grid item xs={1} display="flex" alignItems="center" justifyContent="end">
        <Button
          variant="contained"
          onClick={() => onEdit(counterparty.id)}
          disableElevation
          sx={{ textTransform: 'none', px: 2, py: 1, mb: 0.5, fontWeight: 500, bgcolor: 'text.secondary' }}
        >
          Editar
        </Button>
      </Grid>
    </Grid>
  );
};

export default BeneficiaryRow;
